import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ngxNumberWithDot' })
export class NumberWithCommasPipe implements PipeTransform {

  transform(input: number): string {
    return input ? input.toLocaleString('vi-VN'): ''
  }
}
